import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { Push, PushObject, PushOptions } from '@ionic-native/push';
import { AlertController } from "ionic-angular";
import { Usuario } from "../../entities/usuario";


const options: PushOptions = {
    android: {
        forceShow: true,
        vibrate: true
    },
    ios: {},
    windows: {},
    browser: {
        pushServiceURL: 'http://push.api.phonegap.com/v1/push'
    }
};

@Injectable()
export class Notifications {

    constructor(private _push: Push, private _alertCtrl: AlertController, private _storage: Storage) { }

    public prepare(usuario: Usuario): void {
        this._push.hasPermission().then((res: any) => {
            if (res.isEnabled) {
                this._createChanel(usuario);
            } else {
                console.warn('Não temos permissão para enviar notificações.');
            }
        }).catch(err => console.error(err));
    }

    private _createChanel(usuario: Usuario): void {
        this._push.createChannel({
            id: `channel-user-${usuario.NomeUsuario}`,
            description: `Canal de notificações do ${usuario.Perfil} @${usuario.NomeUsuario}`,
            importance: 4,
            sound: "sounddefault"
        }).then(() => {
            this._createPushObject(usuario);
        }).catch(err => { console.error(err); });
    }

    private _createPushObject(usuario: Usuario): void {
        const pushObject: PushObject = this._push.init(options);

        pushObject.on('notification').subscribe(notification => {
            this._alertCtrl.create({
                title: notification.title,
                message: notification.message
            }).present();
        });

        pushObject.on('registration').subscribe(registration => {
            this._storage.get('registrationId').then(registrationId => {
                console.log('Registrando');
            });
        });

        pushObject.on('error').subscribe(error => {
            console.error('Error with Push plugin', error);
        });
    }

    public destroy(usuario: Usuario): void {
        this._storage.get('registrationId').then(registrationId => {
            console.log(registrationId);
            this._storage.clear();
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/notifications/notifications.ts